/////////////////////// Fetch Project Program Areas Budget //////////////////////////
import Api from '../../../lib/api';
export const PROJECT_PROGRAMME_AREAS = {
	start: 'fetch_start/project_programme_areas',
	end: 'fetch_end/project_programme_areas',
	success: 'fetch_success/project_programme_areas',
	failed: 'fetch_failed/project_programme_areas'
};
export const projectProgrammeAreasFetchStart = () => ({
	type: PROJECT_PROGRAMME_AREAS.start
});

export const projectProgrammeAreasFetchEnd = () => ({
	type: PROJECT_PROGRAMME_AREAS.end
});

export const projectProgrammeAreasFetchSuccess = (data) => {
	return{
		type: PROJECT_PROGRAMME_AREAS.success,
		data
	}};

export const projectProgrammeAreasFetchFailed = (error) => ({
	type: PROJECT_PROGRAMME_AREAS.failed,
	error
});

export const fetchProjectProgrammeArea = (id, year) => (dispatch, getState) => {
	dispatch(projectProgrammeAreasFetchStart());
	return Api.get(Api.API_PROJECT_PROGRAMME_AREAS(id, year)).then(resp => {
		if (resp.data && resp.success) {
			dispatch(projectProgrammeAreasFetchEnd());
			dispatch(projectProgrammeAreasFetchSuccess(resp.data));
		}
		else {
			dispatch(projectProgrammeAreasFetchEnd());
		}
	}).catch((exception) => {
		dispatch(projectProgrammeAreasFetchEnd());
		dispatch(projectProgrammeAreasFetchFailed());
	});
};


// WEBPACK FOOTER //
// ./shared/actions/projectDetailActions/projectProgramArea.js